module.exports = __webpack_public_path__ + "img/item_part_motor.dca1af1c.png";